import { render } from "./App.vue?vue&type=template&id=0323bf2e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0323bf2e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0323bf2e"]])

export default __exports__